import React, { useState, useEffect, createContext } from "react";
import "../styles/Pages.scss";
import HomePage from "./HomePage";
import DetailPage from "./DetailPage";
import FormPage from "./form/FormPage";
import RegisteredPage from "./form/RegisteredPage";
import EndPage from "./form/EndPage";
import CouponsPage from "./CouponsPage";

export const PageContext = createContext();

/* ✅ 1. 所有背景圖 */
const imagesToPreload = [
  "./images/home_page_background.jpg",
  "./images/detail_page_background.jpg",
  "./images/form_page_background.jpg",
  "./images/coupons_page_background.jpg",
  "./images/end_page_background.jpg",
  "./images/submit_button.png",
  "./images/one_day_button.png",
  "./images/join_button.png",
  "./images/get_coupons_button.png",
  "./images/back_to_home_page_button.png",
  "./images/upload_image_button.png",
  "./images/Wellcome.png",
  "./images/Watson.png",
  "./images/PNS.png",
  "./images/Manning.png",
  "./images/HKTVmall.png",
  "./images/buy_link.png",
  "./images/tnc_button.png",
];

/* ✅ 2. preload function */
const preloadImages = (imageUrls) => {
  return Promise.all(
    imageUrls.map((url) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = url;
        img.onload = resolve;
        img.onerror = resolve;
      });
    }),
  );
};

/* ✅ 3. step mapping（for ?p=xxx） */
const stepMap = {
  coupons: 5,
  // form: 2,
  // detail: 1,
  // test: 0,
};

const getInitialStep = () => {
  const params = new URLSearchParams(window.location.search);
  const p = params.get("p");
  return stepMap[p] ?? 5;
};

const Pages = () => {
  const [currentStep, setCurrentStep] = useState(getInitialStep);
  const [isLoading, setIsLoading] = useState(true);

  /* ✅ 4. preload ALL assets */
  useEffect(() => {
    const start = Date.now();

    preloadImages(imagesToPreload).then(() => {
      const elapsed = Date.now() - start;
      const delay = Math.max(0, 800 - elapsed); // 最少0.8秒

      setTimeout(() => {
        setIsLoading(false);
      }, delay);
    });
  }, []);

  const dataValue = {
    currentStep,
    setCurrentStep,
  };

  /* ✅ 5. loading screen gate */
  if (isLoading) {
    // return <div className="loading-screen">Loading...</div>;
    return;
  }

  return (
    <PageContext.Provider value={dataValue}>
      <div className="pages-container">
        {currentStep === 0 && <HomePage />}
        {currentStep === 1 && <DetailPage />}
        {currentStep === 2 && <FormPage />}
        {currentStep === 3 && <RegisteredPage />}
        {currentStep === 4 && <EndPage />}
        {currentStep === 5 && <CouponsPage />}
      </div>
    </PageContext.Provider>
  );
};

export default Pages;
